import { locale } from 'services/locale/en';
import { languages } from 'services/locale';

export const initialState = { locale, lang: languages.EN };
